import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import * as ac from "./action-creators";
import initialQuotaState from "./initial-state";
import type { QuotaState } from "./types";

const quotaReducer = createReducer<QuotaState, ActionType<typeof ac>>(initialQuotaState)
    .handleAction(
        ac.setDataCostVisibility,
        (state, { payload }): QuotaState => ({
            ...state,
            isDataCostVisible: payload,
        }),
    )
    .handleAction(
        ac.toggleDataCostVisibility,
        (state): QuotaState => ({
            ...state,
            isDataCostVisible: !state.isDataCostVisible,
        }),
    )
    .handleAction(
        ac.setDataCreditsModalOpen,
        (state, { payload }): QuotaState => ({
            ...state,
            isDataCreditsModalOpen: payload,
        }),
    )
    .handleAction(
        ac.setQuotaContactAdminModalOpen,
        (state, { payload }): QuotaState => ({
            ...state,
            isQuotaContactAdminModalOpen: payload,
        }),
    );

export default quotaReducer;
